import { Action } from '@ngrx/store';
import { User } from './../../home/models/home';
import { ResultboradDraft, RosterPosition, LeagueScore, MiniLobbyScore, GamePosition,
        BestBallPickCount, SoundToggle, DraftTurn, DeafultRank, PickedPlayers, PickNumber, PlayersList, DraftStatus, CurrentTournament, MobileScreen, AuthUser, UserBalance, DraftPositions, AutoDraftEnable, ByeWeek,DarkMode } from './../../resultboard/model/resultboard';
import { Draft, DraftScore } from './../../resultboard/draft/model/draft';
import { myTeamList } from './../../_models/index';


export const USER_LOGIN = 'User_Login';
export const USER_LOGOUT = 'User_logout';
export const LEAGUE_ID = 'League_ID';
export const LEAGUE_DATA = 'League_Data';
export const LEAGUE_SCORE_DATA = 'League_Score_Data';
export const MY_TEAM_DATA = 'My_Team_Data';
export const ROSTER_DATA = 'ROSTER_DATA';
export const SCORE_DATA = 'SCORE_DATA';
export const MINI_LOBBY_DATA = 'MINI_LOBBY_DATA';
export const TOURNAMENT_MINI_LOBBY_DATA = 'TOURNAMENT_MINI_LOBBY_DATA';
export const GAME_POSITION_DATA = 'GAME_POSITION_DATA';
export const BEST_BALL_PICK_COUNT = 'BEST_BALL_PICK_COUNT';
export const SOUND_TOGGLE = 'SOUND_TOGGLE';
export const DEAFULT_RANK_TOGGLE = 'DEAFULT_RANK_TOGGLE';
export const DRAFT_TURN = 'DRAFT_TURN';
export const PICKED_PLAYERS = 'PICKED_PLAYERS';
export const PICK_NUMBER = 'PICK_NUMBER';
export const PLAYERS_LIST_DATA = 'PLAYERS_LIST_DATA';
export const DRAFT_STATUS_DATA = 'DRAFT_STATUS_DATA'; 
export const CURRENT_TOURNAMENT_DATA = 'CURRENT_TOURNAMENT_DATA';
export const MOBILE_SCREEN = 'MOBILE_SCREEN';
export const AUTH_USER = 'AUTH_USER';
export const EXTEND_LOGOUT_TIMER = '[Application] Extend the logout timer.';
export const LOG_IN = '[Application] Log In';
export const LOG_OUT = '[Application] Log out';
export const DRAFT_POSITIONS = 'DRAFT_POSITIONS';
export const AUTO_DRAFT_ENABLE = 'AUTO_DRAFT_ENABLE';
export const BYE_WEEK = 'BYE_WEEK';
export const DARK_MODE ='DARK_MODE';
export const USER_BALANCE = 'USER_BALANCE';

export class MyTeamData implements Action {
    readonly type = MY_TEAM_DATA;
    constructor(public payload: myTeamList) { }
}

export class LoginUser implements Action {
    readonly type = USER_LOGIN;
    constructor(public payload: User) { }
}

export class LogoutUser implements Action {
    readonly type = USER_LOGOUT;
    constructor(public user_id: number) { }
}

export class LeagueData implements Action {
    readonly type = LEAGUE_DATA;
    constructor(public payload: Draft) { }
}

export class LeagueScoreData implements Action {
    readonly type = LEAGUE_SCORE_DATA;
    constructor(public payload: DraftScore) { }
}


export class LeagueID implements Action {
    readonly type = LEAGUE_ID;
    constructor(public payload: ResultboradDraft) { }
}

export class RosterData implements Action {
    readonly type = ROSTER_DATA;
    constructor(public payload: RosterPosition) { }
}

export class ScoringData implements Action {
    readonly type = SCORE_DATA;
    constructor(public payload: LeagueScore) { }
}

export class MiniLobbyData implements Action {
    readonly type = MINI_LOBBY_DATA;
    constructor(public payload: MiniLobbyScore) { }
}

export class TournamentMiniLobbyData implements Action {
    readonly type = TOURNAMENT_MINI_LOBBY_DATA;
    constructor(public payload: MiniLobbyScore) { }
}

export class GamePositionData implements Action {
    readonly type = GAME_POSITION_DATA;
    constructor(public payload: GamePosition) { }
}

export class BestBallPickCountData implements Action {
    readonly type = BEST_BALL_PICK_COUNT;
    constructor(public payload: BestBallPickCount) { }
}

export class SoundToggleData implements Action {
    readonly type = SOUND_TOGGLE;
    constructor(public payload: SoundToggle) { }
}

export class DeafultRankData implements Action {
    readonly type = DEAFULT_RANK_TOGGLE;
    constructor(public payload: DeafultRank) { }
}

export class DraftTurnData implements Action {
    readonly type = DRAFT_TURN;
    constructor(public payload: DraftTurn) { }
}

export class PickedPlayersData implements Action {
    readonly type = PICKED_PLAYERS;
    constructor(public payload: PickedPlayers) { }
}

export class PickNumberData implements Action {
    readonly type = PICK_NUMBER;
    constructor(public payload: PickNumber) { }
}

export class PlayersListData implements Action {
    readonly type = PLAYERS_LIST_DATA;
    constructor(public payload: PlayersList) { }
}

export class ChangeInDraft implements Action {
    readonly type = DRAFT_STATUS_DATA;
    constructor(public payload: DraftStatus) { }
}

export class CurrTournamentData implements Action {
    readonly type = CURRENT_TOURNAMENT_DATA;
    constructor(public payload: CurrentTournament) { }
}

export class MobileScreenData implements Action {
    readonly type = MOBILE_SCREEN;
    constructor(public payload: MobileScreen) { }
}

export class PositionsRemovedData implements Action {
    readonly type = DRAFT_POSITIONS;
    constructor(public payload: DraftPositions) { }
}

export class AutoDraftEnableData implements Action {
    readonly type = AUTO_DRAFT_ENABLE;
    constructor(public payload: AutoDraftEnable) { }
}

export class AuthUserData implements Action {
    readonly type = AUTH_USER;
    constructor(public payload: AuthUser) { }
}

export class UserBalanceData implements Action {
    readonly type = USER_BALANCE;
    constructor(public payload: UserBalance) { }
}

export class ByeWeekList implements Action {
    readonly type = BYE_WEEK;
    constructor(public payload: ByeWeek) { }
}
export class DarkModeAction implements Action {
    readonly type = DARK_MODE;
    constructor(public payload: DarkMode) { }
}

export class ExtendLogoutTimer implements Action { readonly type = EXTEND_LOGOUT_TIMER; }
export class LogIn implements Action { readonly type = LOG_IN; }
export class LogOut implements Action { readonly type = LOG_OUT; }


export type Actions = LoginUser | LogoutUser | LeagueData | LeagueID | LeagueScoreData | MyTeamData | RosterData | ScoringData | MiniLobbyData |
TournamentMiniLobbyData | GamePositionData | BestBallPickCountData | SoundToggleData | DeafultRankData | DraftTurnData | PickedPlayersData | PickNumberData | PlayersListData | ChangeInDraft | CurrTournamentData | MobileScreenData | AutoDraftEnableData | AuthUserData | UserBalanceData | PositionsRemovedData | ExtendLogoutTimer | ByeWeekList | DarkModeAction
| LogIn
| LogOut;
